import type {ReactElement} from 'react';
import React from 'react';
import {PosterEditingBaseColorPanel} from '@Components/poster-editor/components/poster-editing-side-panel/components/poster-editing-base-color-panel';
import type {ColorStorage} from '@Components/color-picker-v2';
import {getRGBAArrayFromColorStorage} from '@Utils/color.util';
import {updateLastDrawBrushColor} from '@Components/poster-editor/library/poster-editor-library';
import {useAppSelector} from '@/hooks';

export function DrawColorPanel(): ReactElement<any> {
  const color = useAppSelector((state) => {
    return state.posterEditor.posterObject?.drawing.drawBrush?.strokeColor;
  });

  if (!color) {
    throw new Error('Color does not exist for drawing');
  }

  const getColor = (): ColorStorage[] => {
    return [
      {
        id: 'primary',
        color: color,
      },
    ];
  };

  const updateColor = (updatedColor: ColorStorage[]): void => {
    const updatedRGBAColor = getRGBAArrayFromColorStorage(updatedColor)[0];
    window.posterEditor?.whiteboard?.drawing.updateDrawModeColor(updatedRGBAColor);
    updateLastDrawBrushColor(updatedRGBAColor);
  };

  const onChangeColor = (updatedColor: ColorStorage[]): void => {
    updateColor(updatedColor);
  };
  const onChangeEnded = (updatedColor: ColorStorage[]): void => {
    updateColor(updatedColor);
  };

  return <PosterEditingBaseColorPanel id="draw-color-panel" color={getColor()} onChangeColor={onChangeColor} onChangeEnded={onChangeEnded} isGradientEnabled={false} />;
}
